import { NavLink } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="fixed bottom-0 z-20 hidden min-h-11 w-full items-center justify-center bg-blue-50/95 pl-14 shadow-[0_-1px_8px_rgba(15,23,42,0.04)] backdrop-blur-sm sm:flex">
      <div className="mb-1 font-BarlowCondensed">
        <div className="flex w-full items-center justify-center gap-6">
          <div className="flex py-2 text-xs text-nxm-dark-gray md:text-sm">
            <NavLink to="/legalnotice" className="underline">
              Mentions légales
            </NavLink>
            <p className="px-1">-</p>
            <NavLink to="/cookiesnotice" className="underline">
              {" "}
              Cookies
            </NavLink>
            <p className="px-1">-</p>
            <NavLink to="/cgu" className="underline">
              CGU
            </NavLink>
          </div>
          <p className="hidden pb-1 pt-1 text-center text-xs font-extralight md:block">
            © 2026 by Trionode.
          </p>
        </div>
      </div>
    </footer>
  );
};
export default Footer;
